module.exports = __webpack_public_path__ + "static/img/q5.2ba40c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/q5.png
// module id = GwIu
// module chunks = 0